import * as React from 'react';
import { workflowSettingsViewStore } from 'utils/MobxDataManager/singletons';

interface IRemoveUserDialogProps {
    // Need to have props for the super in the constructor even if it's empty
    // for classes that have inheritance
}

export class RemoveUserDialog extends React.Component<IRemoveUserDialogProps> {
    constructor(props: IRemoveUserDialogProps) {
        super(props);
        this.removeAssignedUser = this.removeAssignedUser.bind(this);
        this.unsetAssignedUser = this.unsetAssignedUser.bind(this);
    }

    render(): React.ReactNode {
        return this.renderRemoveAssignedUserWarningBox();
    }

    private renderRemoveAssignedUserWarningBox(): React.ReactNode {
        const { _assignedUserId } = workflowSettingsViewStore.
            removeAssignedUserStore;
        if (!_assignedUserId) {
            return null;
        }

        return (
            <div className="pxl-modal confirmation-modal">
                <div className="pxl-modal__content">
                    <h1 className="pxl-header-xsmall">{this.modalTitleText()}</h1>
                    <div>
                        {this.modalContentText()}
                    </div>
                    <div className="pxl-text-right">
                        <button className="pxl-link" onClick={this.unsetAssignedUser}>Cancel</button>
                        <button
                            onClick={this.removeAssignedUser}
                            className="pxl-btn pxl-btn--primary pxl-margin-left-large"
                        >
                            Remove
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private modalTitleText(): string {
        const store = workflowSettingsViewStore.removeAssignedUserStore;
        return `Remove ${store.assignedUserLevel}`;
    }

    private modalContentText(): string {
        const store = workflowSettingsViewStore.removeAssignedUserStore;
        const accessGroupText = store._accessGroupDisplayName ? ` for ${store._accessGroupDisplayName}` : '';
        return `Are you sure you want to remove ${store.assignedUserLevel}${accessGroupText}?`;
    }

    private async removeAssignedUser(): Promise<void> {
        await workflowSettingsViewStore.removeAssignedUser();
    }

    private unsetAssignedUser(): void {
        workflowSettingsViewStore.removeAssignedUserStore.unsetAssignedUser();
    }
}